import React, { useMemo, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query'; //-tech-debt-react-query;
import { useSelector } from 'react-redux';
import { MenuItem, TextField } from '@mui/material';
import { Product } from '../../types/product';
import { postItem } from '../../support/queries';
import { useParams } from 'react-router-dom';
import StbButton from '../security-toolbox-ui/StbButton';
import StbApiModal from '../security-toolbox-ui/StbModal';
import { RootState } from '../../support/store';
import { CacheKey } from '../../types/cache-keys';


interface ServiceCreationProductProps {
  selectedProducts: Product['id'][];
  onProductSelect: (productId: number) => void; // Callback for selected product ID
}

const ServiceCreationProduct: React.FC<ServiceCreationProductProps> = ({ selectedProducts, onProductSelect }) => {
  const { id } = useParams();
  const queryClient = useQueryClient();

  const products = useSelector((state: RootState) => state.products.items);
  const [openAddProductModal, setOpenAddProductModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState<Product | null>(null);
  const availableProducts = useMemo(() => products?.filter(
    (product) => product.vendor.is_cisco === true && product.mssp_service_creation && !selectedProducts.includes(product.id)
  ), [products, selectedProducts]);

  const handleAddServiceCreation = async () => {
    if (!selectedProduct) return;

    const newServiceCreation = {
      partner_id: Number(id),
      product_id: selectedProduct.id,
      overall_status: 'Not started',
      status: 'No Activity',
      target_launch_date: new Date().toISOString(),
      service_creation_stage: 'Not started',
      service_launch_date: new Date().toISOString(),
      cisco_powered: 'No',
      version_id: null,
      license_id: null,
      created: new Date().toISOString(),
      last_updated: new Date().toISOString(),
      updated_by: null,
    };

    const response = await postItem('db/service-creation', newServiceCreation);
    if (response) {
      queryClient.invalidateQueries({ queryKey: [CacheKey.ServiceCreation] });
      onProductSelect(selectedProduct.id); // Notify parent component
    }
  };

  const handleSelectChange = (value: string) => {
    const selectedProd = products?.find((p) => p.name === value);
    setSelectedProduct(selectedProd || null);
  };

  return (
    <div>
      <StbButton
        role="add"
        onClick={() => setOpenAddProductModal(true)}
        disabled={!availableProducts || availableProducts?.length === 0}
      >
        Add New Product
      </StbButton>
      <StbApiModal
        open={openAddProductModal}
        title="Add Service Creation Product"
        role="save"
        submitDisabled={!selectedProduct}
        onSubmit={handleAddServiceCreation}
        onClose={async () => {
          setOpenAddProductModal(false)
          setSelectedProduct(null);
        }}
      >
        <TextField
          margin="dense"
          label="Available Products"
          variant="outlined"
          select
          value={selectedProduct?.name || ''}
          onChange={(e) => handleSelectChange(e.target.value)}
          fullWidth
        >
          <MenuItem value="" disabled>
            <em>Select Type</em>
          </MenuItem>
          {availableProducts
            .map((product) => (
              <MenuItem key={product.id} value={product.name}>
                {product.name}
              </MenuItem>
            ))}
        </TextField>
      </StbApiModal>
    </div>
  );
};

export default ServiceCreationProduct;